import { Menu } from '@headlessui/react';
import { UserMenuItemButton } from '@library/components/menus/userMenu/UserMenuItemButton';

export interface UserMenuItemProps {
  disabled: boolean;
  handleOnClick: () => void;
  message: string;
}

export const UserMenuItem = ({
  disabled,
  handleOnClick,
  message
}: UserMenuItemProps) => {
  return (
    <Menu.Item>
      <UserMenuItemButton
        className="hover:bg-soFresh-140 text-soClean-100 group z-40 flex h-8 w-full items-center px-5 py-2 text-sm font-normal leading-5"
        disabled={disabled}
        handleOnClick={handleOnClick}
        message={message}
      />
    </Menu.Item>
  );
};
